import React, { useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { WebService } from "../../Services/WebService";
import { Form, FormInputText } from "../Form";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { PageInfo } from "../PageInfo";
import { DateTime } from "luxon";
import { StandardConst } from "../../Services/StandardConst";

const { forwardRef, useState, useImperativeHandle } = React;

const ViewRegularizationDetails = (prop, ref) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [data, setData] = useState({});
  const [readOnly, setReadOnly] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal: async (id, IsReadOnly) => {
      IsReadOnly ??= false;
      const data = await WebService({
        endPoint: `AttendanceRegularization/FetchDetails/${id || 0}`,
        dispatch,
      }).then((c) => (c.length > 0 ? c[0] : {}));
console.log('ABHI OriginalInTime',data)
      // Format times for display
      if (data.CorrectedInTime) {
        data.DisplayInTime = DateTime.fromSQL(data.CorrectedInTime).toFormat("hh:mm a");
      }
      if (data.CorrectedOutTime) {
        data.DisplayOutTime = DateTime.fromSQL(data.CorrectedOutTime).toFormat("hh:mm a");
      }
      if (data.OriginalInTime) {
        data.DisplayOriginalInTime = DateTime.fromSQL(data.OriginalInTime).toFormat("hh:mm a");
      }
      if (data.OriginalOutTime) {
        data.DisplayOriginalOutTime = DateTime.fromSQL(data.OriginalOutTime).toFormat("hh:mm a");
      }

      setData(data);
      setReadOnly(IsReadOnly);
      setShow(true);
    },
  }));

// useImperativeHandle(ref, () => ({
//   openModal: async (id, IsReadOnly) => {
//     try {
//       console.log("🔍 ViewRegularizationDetails - Opening modal for ID:", id);
      
//       IsReadOnly ??= false;
      
//       const response = await WebService({
//         endPoint: `AttendanceRegularization/FetchDetails/${id || 0}`,
//         dispatch,
//       });
      
//       console.log("✅ ViewRegularizationDetails - API Response:", response);
      
//       const data = response?.length > 0 ? response[0] : (response || {});

//       // Format times for display
//       if (data.CorrectedInTime) {
//         data.DisplayInTime = DateTime.fromSQL(data.CorrectedInTime).toFormat("hh:mm a");
//       }
//       if (data.CorrectedOutTime) {
//         data.DisplayOutTime = DateTime.fromSQL(data.CorrectedOutTime).toFormat("hh:mm a");
//       }
//       if (data.OriginalInTime) {
//         data.DisplayOriginalInTime = DateTime.fromSQL(data.OriginalInTime).toFormat("hh:mm a");
//       }
//       if (data.OriginalOutTime) {
//         data.DisplayOriginalOutTime = DateTime.fromSQL(data.OriginalOutTime).toFormat("hh:mm a");
//       }

//       console.log("✅ ViewRegularizationDetails - Setting data and showing modal");
//       setData(data);
//       setReadOnly(IsReadOnly);
//       setShow(true);
//     } catch (error) {
//       console.error("❌ ViewRegularizationDetails - Error:", error);
//       alert("Error loading regularization details: " + error.message);
//     }
//   },
// }));


  PageInfo({ pageTitle: "Regularization Details" });

  const handleClose = () => setShow(false);

  const schema = yup.object().shape({}).required();

  const formRef = useRef();

  const getStatusText = (statusId) => {
    switch (statusId) {
      case 1:
        return "Pending";
      case 2:
        return "Approved";
      case 3:
        return "Rejected";
      case 4:
        return "Cancelled";
      default:
        return "Unknown";
    }
  };

  const styleObj = {
    fontSize: 14,
    fontFamily: "sans-serif",
    color: "rgb(108 106 106)",
    paddingTop: "6px",
  };
console.log('ab5555');
  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={handleClose}
      centered
      className="container-fluid"
    >
      <Modal.Header closeButton>
        <Modal.Title>View Regularization Details</Modal.Title>
      </Modal.Header>

      <Form ref={formRef} defaultValues={data} validationSchema={schema}>
        <Modal.Body className="p-4">
          <div className="row mt-1">
            <FormInputText
              label="Employee Name"
              name="EmployeeName"
              disabled={true}
            />
          </div>

          <div className="row mt-2">
            <FormInputText
              label="Request Date"
              name="RequestDate"
              type="date"
              disabled={true}
            />
          </div>

          <div className="row mt-2">
            <FormInputText
              label="Attendance Date"
              name="AttendanceDate"
              type="date"
              disabled={true}
            />
          </div>

          <div className="row mt-2">
            <FormInputText
              label="Request Type"
              name="RequestTypeName"
              disabled={true}
            />
          </div>

 {data.DisplayOriginalInTime && (
    <>
              <div className="row mt-2">
                <div className="col-md-12">
                  {/* <label style={styleObj}>Original Punch Time</label> */}
                </div>
              </div>
                <div className="row mt-2">
                  <FormInputText
                        label="In Time"
                        name="DisplayOriginalInTime"
                        disabled={true}
                      />
                </div>
                <div className="row mt-2">
                  <FormInputText
                          label="Out Time"
                          name="DisplayOriginalOutTime"
                          disabled={true}
                        />
                </div>
                </>
)}
 
{data.DisplayInTime && (
  <>
                <div className="row mt-2">
                  <div className="col-md-12">
                    {/* <label style={styleObj}>Corrected Punch Time</label> */}
                  </div>
                </div>
                <div className="row mt-2">
                   <FormInputText
                  label="In Time"
                  name="DisplayInTime"
                  disabled={true}
                />
                </div>
                <div className="row mt-2">
                  <FormInputText
                  label="Out Time"
                  name="DisplayOutTime"
                  disabled={true}
                />
                </div>
                </>
                 )}

          {/*{data.DisplayOriginalInTime && (
            <div className="row mt-2">
              <div className="col-md-12">
                <label style={styleObj}>Original Punch Time</label>
              </div>
              <div className="col-md-6">
                <FormInputText
                  label="In Time"
                  name="DisplayOriginalInTime"
                  disabled={true}
                />
              </div>
              <div className="col-md-6">
                <FormInputText
                  label="Out Time"
                  name="DisplayOriginalOutTime"
                  disabled={true}
                />
              </div>
            </div>
          )} }

          {/* {data.DisplayInTime && (
            <div className="row mt-2">
              <div className="col-md-12">
                <label style={styleObj}>Corrected Punch Time</label>
              </div>
              <div className="col-md-6">
                <FormInputText
                  label="In Time"
                  name="DisplayInTime"
                  disabled={true}
                />
              </div>
              <div className="col-md-6">
                <FormInputText
                  label="Out Time"
                  name="DisplayOutTime"
                  disabled={true}
                />
              </div>
            </div>
          )} */}

          <div className="row mt-2">
            <FormInputText
              name="Remarks"
              label="Reason for Regularization"
              as="textarea"
              rows={3}
              disabled={true}
            />
          </div>

         

          <div className="row mt-2">
            <FormInputText
              label="Status"
              value={getStatusText(data.StatusId)}
              name="Status"
              disabled={true}
            />
          </div>

          {data.ApproverName && (
            <div className="row mt-2">
              <FormInputText
                label="Approved/Rejected By"
                name="ApproverName"
                disabled={true}
              />
            </div>
          )}

          {data.ApprovalNote && (
            <div className="row mt-2">
              <FormInputText
                name="ApprovalNote"
                label="Manager's Comment"
                as="textarea"
                rows={3}
                disabled={true}
              />
            </div>
          )}

          {data.ApprovedOn && (
            <div className="row mt-2">
              {/* <FormInputText
                label="Action Taken On"
                value={DateTime.fromISO(data.ApprovedOn).toFormat("dd MMM yyyy, hh:mm a")}
                disabled={true}
              /> */}
            </div>
          )}

           {data.Attachment && (
            <div className="row mt-2">
              <div className="col-md-12">
                <label style={styleObj}>Attachment</label>
                {/* <img class="pic rounded-circle" src={`${StandardConst.apiBaseUrl}/uploads/${data.Attachment}` ||  `${StandardConst.apiBaseUrl}/uploads/user_placeholder.jpg`} alt=""></img> */}
                <br />
               <a
                  href={`${StandardConst.apiBaseUrl}/uploads/${data.Attachment}` || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Attachment
                </a>
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default forwardRef(ViewRegularizationDetails);